import React from 'react';
import PackageBoughtComponent from '../../../Components/Customer/PackageBought';

export default function PackageBought() {
    return (
        <div className='page-body'>
            <PackageBoughtComponent />
        </div>
    );
}